import { Database, withLogs } from '@core';
import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

export type ActivityTag = {
    createdAt: string;
    deleted: boolean;
    deletedAt: string | null;
    id: number;
    name: string;
    userId: string | null;
};

const activityTagsQuery = `
    *,
    activity_tags(*)
` as const;

export const fetchActivityTags = withLogs(async (supabase: SupabaseClient<Database>, activityId: number) => {
    const { data, error } = await supabase
        .from('activity_tag_link')
        .select(activityTagsQuery)
        .eq('activity_id', activityId)
        .eq('deleted', false);

    if (error) {
        throw error;
    }

    const converted = camelcaseKeys(data, { deep: true }) || [];
    return converted.map(({ activityTags }): ActivityTag => activityTags);
}, 'fetchActivityTags');

export const clearActivityTags = withLogs(async (supabase: SupabaseClient<Database>, activityId: number) => {
    const { error } = await supabase.from('activity_tag_link').delete().eq('activity_id', activityId);
    if (error) {
        throw error;
    }
}, 'clearActivityTags');

export const updateActivityTags = withLogs(
    async (supabase: SupabaseClient<Database>, activityId: number, tagIds: number[]) => {
        const deleteRes = await supabase.from('activity_tag_link').delete().eq('activity_id', activityId);
        if (deleteRes.error) {
            throw deleteRes.error;
        }
        const { error } = await supabase
            .from('activity_tag_link')
            .insert(snakecaseKeys(tagIds.map((tagId) => ({ tagId, activityId }))));

        if (error) {
            throw error;
        }
    },
    'updateActivityTags',
);
